// No React import needed with modern JSX transform
import { MInputField } from "@/components/ui/atoms/MInputField";
import { IconBrandFigma } from "@tabler/icons-react";
import MTimeInputField from '@/components/ui/atoms/MTimeInputField';

const InputTest = () => {
  return (
    <div style={{ maxWidth: 480, margin: '0 auto', padding: 24, paddingBottom: 64, display: 'flex', flexDirection: 'column', gap: 32 }}>
      <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>
        Label + Mandatory, Size: xl, Variant: Outlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Outlined"
        size="xl"
        showLabel
        label="Label Text"
        mandatory
        showIcon
      />
      <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>
        Label + Mandatory, Size: md, Variant: Underlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Underlined"
        size="md"
        showLabel
        label="Label Text"
        mandatory
        showIcon
      />
      <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>
        State: Default, Size: xl, Variant: Outlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Outlined"
        size="xl"
        showIcon
      />
      <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>
        Outlined XL with Brand Figma Icon
      </div>
      <MInputField
        placeholder="Figma username"
        variant="Outlined"
        size="xl"
        showIcon
        icon={<IconBrandFigma />}
        label="Figma"
        showLabel
      />
      <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>
        Outlined XL with Error State Message
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Outlined"
        size="xl"
        state="Error"
        stateMessage="Please enter a valid email address."
      />
      <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>
        Outlined XL with Success State Message
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Outlined"
        size="xl"
        state="Success"
        stateMessage="Looks good!"
      />
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        State: Default, Size: md, Variant: Underlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Underlined"
        size="md"
        showIcon
      />
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        State: Disabled, Size: xl, Variant: Outlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Outlined"
        size="xl"
        state="Disabled"
        showIcon
        disabled
      />
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        State: Disabled, Size: md, Variant: Underlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Underlined"
        size="md"
        state="Disabled"
        showIcon
        disabled
      />
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        State: Error, Size: xl, Variant: Outlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Outlined"
        size="xl"
        state="Error"
        showIcon
        value="Error Value"
      />
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        State: Error, Size: md, Variant: Underlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Underlined"
        size="md"
        state="Error"
        showIcon
        value="Error Value"
      />
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        State: Success, Size: xl, Variant: Outlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Outlined"
        size="xl"
        state="Success"
        showIcon
        value="Success Value"
      />
      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        State: Success, Size: md, Variant: Underlined
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Underlined"
        size="md"
        state="Success"
        showIcon
        value="Success Value"
      />

    <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        Underlined md with Error State Message
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Underlined"
        size="md"
        state="Error"
        showStateMessage
        stateMessage="Please enter a valid email address."
      />
      <div style={{ marginBottom: 8, fontWeight: 600, fontSize: 16 }}>
        Underlined md with Success State Message
      </div>
      <MInputField
        placeholder="Placeholder"
        variant="Underlined"
        size="md"
        state="Success"
        showStateMessage
        stateMessage="Looks good!"
      />

      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        MTimeInputField (12-hour)
      </div>
      <MTimeInputField
        label="Time (12-hour)"
        showLabel
        format={12}
        variant="Underlined"
        size="md"
        placeholder="hh:mm AM/PM"
      />

      <div style={{ margin: '32px 0 8px 0', fontWeight: 600, fontSize: 16 }}>
        MTimeInputField (24-hour)
      </div>
      <MTimeInputField
        label="Time (24-hour)"
        showLabel
        variant="Outlined"
        size="xl"
        placeholder="HH:mm"
      />
    </div>
  );
};

export default InputTest;
